module.exports = __webpack_public_path__ + "bgHeaderOfbiz.png?8738ec2f073edce9c5f22e32ebbf5634";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bgHeaderOfbiz.png
// module id = 84
// module chunks = 0